import { connect } from "react-redux";
import { Collapse } from "reactstrap";
import { Link } from "react-router-dom";
import { withNamespaces } from "react-i18next";
import classname from "classnames";
import { useEffect, useState } from "react";
import { selectOrgCustomization } from "src/store/orgCustomizations/reducer";

const LoadingComponent = () => {
    return (
        <>
            {/* <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item horizontal" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item horizontal" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item w-50" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item horizontal" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item horizontal" />
            </li>
            <li className='afc-dropdown'>
                <div className="loading-placeholder menu-item horizontal" />
            </li> */}
        </>
    )
}


const HorizontalMenuContent = (props) => {
	const {
		menu,
		t,
        menuOpen,
        modules,
        organization,
        orgCustomization
	} = props;
    const [ isLoading, setIsLoading ] = useState(true);

    const [activeMenuIndex, setActiveMenuIndex] = useState(-1)

    useEffect(() => {
        setIsLoading(!(!modules.isLoading && modules.featuresLoadingStatus === 'loaded'))
    }, [  
        modules.isLoading,
        modules.featuresLoadingStatus
    ]);

	return (
		<Collapse isOpen={ menuOpen } className='navbar-collapse' id='topnav-menu-content'>
			<ul className='navbar-nav'>
                {(() => {
                     if(isLoading){
                        return (
                            <LoadingComponent />
                        )
                    }

                    return menu.map((menuItem, index) => {
						const subMenuItems = menuItem.items || [];
						const hasSubMenu = subMenuItems.length > 0;
						
						return (
                            <li
                                key={index}
                                className={"nav-item" + (hasSubMenu > 0 ? " dropdown" : "")}
                                onClick={() => setActiveMenuIndex(index === activeMenuIndex ? -1 : index)}
                            >
                                {menuItem.linkType === "react-router" ? (
                                menuItem?.path ? (
                                    <Link
                                        className={
                                            "nav-link" +
                                            (hasSubMenu > 0 ? " dropdown-toggle arrow-none" : "")
                                        }
                                        to={menuItem.path}
                                    >
                                        <i className={menuItem?.icon + " me-2"}></i>
                                        {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                            t, 
                                            organization,
                                            orgCustomization,
                                            menuItem
                                        }) : t(menuItem.titleKey)}
                                    </Link>
                                ) : (
                                    <span
                                        className={
                                            "nav-link" +
                                            (hasSubMenu > 0 ? " dropdown-toggle arrow-none" : "")
                                        }
                                    >
                                        <i className={menuItem?.icon + " me-2"}></i>
                                        {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                            t, 
                                            organization,
                                            orgCustomization,
                                            menuItem
                                        }) : t(menuItem.titleKey)}
                                    </span>
                                )
                                ) : menuItem?.path ? (
                                    <a className="nav-link" href={menuItem.path} target="_new">
                                        <i className={menuItem?.icon + " me-2"}></i>
                                        <span className="ms-1">
                                            {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                                t,
                                                organization,
                                                orgCustomization,
                                                menuItem
                                            }) : t(menuItem.titleKey)}
                                        </span>
                                    </a>
                                ) : (
                                    <span className="nav-link">
                                        <i className={menuItem?.icon + " me-2"}></i>
                                        <span className="ms-1">
                                            {typeof menuItem.titleKey === "function" ? menuItem.titleKey({
                                                t,
                                                organization,
                                                orgCustomization,
                                                menuItem
                                            }) : t(menuItem.titleKey)}
                                        </span>
                                    </span>
                                )}

                                {hasSubMenu ? (
                                    <div
                                        className={classname("dropdown-menu dropdown-menu-end", {
                                            show: activeMenuIndex === index,
                                        })}
                                        aria-labelledby="topnav-apps"
                                    >
                                        {subMenuItems.map((subMenuItem, subMenuItemIndex) => {
                                            return subMenuItem.linkType === "react-router" ? (
                                                <Link
                                                    key={subMenuItemIndex}
                                                    to={subMenuItem?.path}
                                                    className="dropdown-item"
                                                >
                                                    {typeof subMenuItem.titleKey === "function" ? subMenuItem.titleKey({
                                                        t,
                                                        organization,
                                                        orgCustomization,
                                                        subMenuItem
                                                    }) : t(subMenuItem.titleKey)}
                                                </Link>
                                            ) : (
                                                <a
                                                    className="dropdown-item"
                                                    href={subMenuItem?.path}
                                                    target="_new"
                                                >
                                                    {typeof subMenuItem.titleKey === "function" ? subMenuItem.titleKey({
                                                        t,
                                                        organization,
                                                        orgCustomization,
                                                        subMenuItem
                                                    }) : t(subMenuItem.titleKey)}
                                                </a>
                                            );
                                        })}
                                    </div>
                                ) : null}
                            </li>
                        )
					})
                })()}
			</ul>
		</Collapse>
	);
}

const mapStatetoProps = (state) => {
    const { Modules: modules, Organization: organization } = state;
    return {
        modules,
        organization,
        orgCustomization: selectOrgCustomization(state, organization?.id)
    };
};

export default withNamespaces()(
    connect(mapStatetoProps, {})(
        HorizontalMenuContent
    )
);